export const WAVESURFER_PLAYBACK_HEIGHT = 256;
/*
 * "frequencyMax" in spectrogram default was set to 12000 in Wavesurferjs v6 but 4000 in v7
 * Setting to 12000 to remain consistent with before
 */
export const SPECTROGRAM_MAX_FREQUENCY = 12000;

// The sample rate need to be twice the maximum frequency - https://wavesurfer.xyz/docs/types/plugins_spectrogram.SpectrogramPluginOptions
export const SAMPLE_RATE = SPECTROGRAM_MAX_FREQUENCY * 2;
